import React from 'react';
import styles from './label.module.scss';
export default function Label({ htmlFor = '', children }) {
  return (
    <label htmlFor={htmlFor} className={styles.label}>
      {children}
    </label>
  );
}
